var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('Login')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }